import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './i18n'; // Initialize i18n

import ErrorBoundary from './components/ErrorBoundary';
import { LanguageProvider } from './components/ui/LanguageProvider';
import { ThemeProvider } from './components/ui/ThemeProvider';
import { ToastProvider } from './components/ui/Toast';
import { ActivityLogProvider } from './components/activity/ActivityLogContext';
import { AuthProvider } from './contexts/AuthContext';
import { useDirection } from './hooks/useDirection';
import Routes from './Routes';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});


function AppContent() {
  // ✅ run after LanguageProvider is mounted (AppContent is a child)
  useDirection();
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <ActivityLogProvider>
              <ErrorBoundary>
                <Routes />
              </ErrorBoundary>
            </ActivityLogProvider>
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default function App() {
  return (
    // ✅ only one LanguageProvider in the whole app
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}